import { render } from "./HelloWorld.vue?vue&type=template&id=776e7215&scoped=true&ts=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=776e7215&scoped=true&lang=css"

import exportComponent from "/Users/fancyzhong/Desktop/code/hel-eco-of-github/hel-tpl-remote-vue3-comps-ts/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-776e7215"]])

export default __exports__